// ==============================|| THEME CONSTANT ||============================== //

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

// export const APP_DEFAULT_PATH = '/dashboard/default';
export const APP_DEFAULT_PATH = '/dashboard';
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 280;
export const MINI_DRAWER_WIDTH = 90;
export const HEADER_HEIGHT = 74;

// constant variable for ₹ symbol
export const RUPEE_SYMBOL = "₹"

// constant variables for add-product.js file product input fields lengths
// ==========================================================================
// constant variable for product name
export const PRODUCT_NAME_LENGTH = 50;
// constant variable for product description(short)
export const PRODUCT_SHORTDESCRIPTION_LENGTH = 200;
// constant variable for product description
export const PRODUCT_DESCRIPTION_LENGTH = 400;
// constant variable for product specification
export const PRODUCT_SPECIFICATION_LENGTH = 30;
// constant variable for product feactures(key, value) pair
export const PRODUCT_FEATURE_KEY_LENGTH = 20;
export const PRODUCT_FEATURE_VALUE_LENGTH = 30;
// Role Types
export const ROLE_SUB_ADMIN = 3;
export const ROLE_CUSTOMER = 4;
export const ROLE_VAN_DRIVER = 5;
export const ROLE_STORE = 6;

export const ThemeMode = {
  LIGHT: 'light',
  DARK: 'dark'
};

export const MenuOrientation = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};

export const ThemeDirection = {
  LTR: 'ltr',
  RTL: 'rtl'
};

export const DropzopType = {
  default: 'DEFAULT',
  standard: 'STANDARD'
};

// ==============================|| STORE STATUS ||============================== //
export const STATUS_MAPPING = {
  1: { label: 'Waiting for Approval', color: 'warning' },
  2: { label: 'Wailting for Delivery', color: 'info' },
  3: { label: 'Admin Rejected', color: 'error' },
  4: { label: 'Partner Cancelled', color: 'default' },
  5: { label: 'Delivered to In-Store', color: 'success' },
  6: { label: 'Return to partner', color: 'warning' },
  7: { label: 'Return accepted', color: 'success' }
};

// ==============================|| TRANSACTION STATUS ||============================== //

export const transactionStatus = {
  1: 'PENDING',
  2: 'PROCESSING',
  3: 'COMPLETED',
  4: 'FAILED'
};

// ==============================|| RAZORPAY KEYS ||============================== //

export const RAZORPAY_SANDBOX_KEY_ID = 'rzp_test_G5VLiHGBB0YTMp'
export const RAZORPAY_PRODUCTION_KEY_ID = 'rzp_live_O6uwtygHiLOc9n'

export const RAZORPAY_SANDBOX_KEY_SECRET = 'mWMzG5M1nIDDb5x5wXQtd4Hy'
export const RAZORPAY_PRODUCTION_KEY_SECRET = 'UL16K9kcGRoMhI9m4EG7SI3j'

// ==============================|| THEME CONFIG ||============================== //

const config = {
  /**
   * The props used for the theme font-style.
   * We provide static below options -
   * `'Inter', sans-serif`
   * `'Poppins', sans-serif`
   * `'Roboto', sans-serif`
   * `'Public Sans', sans-serif` (default)
   */
  fontFamily: `Nunito`,

  /**
   * The props used for display menu-items with multi-language.
   * We provide static below languages according to 'react-intl' options - https://www.npmjs.com/package/react-intl
   * 'en' (default)
   * 'fr'
   * 'ro'
   * 'zh'
   */
  i18n: 'en',

  /**
   * the props used for menu orientation (diffrent theme layout).
   * we provide static below options -
   * 'vertical' (default)
   * 'horizontal'
   */
  menuOrientation: MenuOrientation.VERTICAL,

  /**
   * the props used for show/hide caption drawer
   * default - true
   * false - will hide menu caption
   */
  menuCaption: true,

  /**
   * the props used for show mini variant drawer
   * the mini variant is recommended for apps sections that need quick selection access alongside content.
   * default - false
   */
  miniDrawer: false,

  /**
   * the props used for theme container.
   * the container centers your content horizontally. It's the most basic layout element.
   * default - true which show container
   * false - will show fluid
   */
  container: false,

  /**
   * the props used for default theme palette mode
   * explore the default theme
   * below theme options -
   * 'light' (default)
   * 'dark'
   */
  mode: ThemeMode.LIGHT,

  /**
   * the props used for theme primary color variants
   * we provide static below options thoe s are already defaine in src/themes/theme -
   * 'default'
   * 'theme1'
   * 'theme2'
   * 'theme3'
   * 'theme4'
   * 'theme5'
   * 'theme6'
   * 'theme7'
   * 'theme8'
   */
  presetColor: 'default',

  /**
   * the props used for default theme direction
   * explore the default theme
   * below theme options -
   * 'ltr' (default)
   * 'rtl'
   */
  themeDirection: ThemeDirection.LTR,

  /**
   * the props used for theme contrast.
   * set box-shadow .
   * default - false which show card without box-shadow and background default
   * true - will show card with box-shadow and background pure white
   */
  themeContrast: false
};

export default config;
